/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const servers = require('./Servers');
const environments = require('./Environments');
const apiHelper = require('./APIHelper');

const environmentsMap = [];

environmentsMap[environments.PRODUCTION] = [];

environmentsMap[environments.PRODUCTION][servers.MDEFAULT] = 'https://api.pipedrive.com/v1';
environmentsMap[environments.PRODUCTION][servers.OAUTH] = 'https://oauth.pipedrive.com/oauth';

const Configuration = {
    // Your private API token
    apiToken: '',

    // The object containing the OAuthToken
    oAuthToken: {},


    // Callback function to be called on token refresh
    // TODO: Replace the oAuthTokenUpdateCallback with an appropriate callback function
    oAuthTokenUpdateCallback: null,


    // OAuth 2 Client ID
    // TODO: Replace the OAuthClientId with an appropriate value
    oAuthClientId: 'TODO: Replace',

    // OAuth 2 Client Secret
    // TODO: Replace the OAuthClientSecret with an appropriate value
    oAuthClientSecret: 'TODO: Replace',

    // OAuth 2 Redirection endpoint or Callback Uri
    // TODO: Replace the OAuthRedirectUri with an appropriate value
    oAuthRedirectUri: 'TODO: Replace',

    // User agent for statistics
    userAgent:'',

    /**
     * Current API environment
     * @type {string}
     */
    currentEnvironment: environments.PRODUCTION,

    /**
     * Get base URI for a server in the current API environment
     * @param  {string|null} server Server name
     * @return {string}             Base URI for server
     */
    getBaseUri(server) {
        const url = environmentsMap[this.currentEnvironment][server || servers.MDEFAULT];
        const urlParams = {
        };
        return apiHelper.appendUrlWithTemplateParameters(url, urlParams);
    },

    getUserAgent(){
        if (this.userAgent) {
            return this.userAgent
        }

        const version = require('../package.json').version;
        this.userAgent = `Pipedrive-SDK-Node-${version}`;

        return this.getUserAgent();
    },
};

module.exports = Configuration;
